import React, { useState, useEffect } from 'react';
import { 
  getUsersByOrganization, 
  createTeam, 
  deleteTeam,
  removeUserFromTeam,
  toggleUserStatus
} from '../../api';
import CreateUser from '../CreateUser';
import EditUserDialog from '../../components/common/EditUserDialog';
import { getTeamsByAgentur } from '../../api';
import { useParams } from 'react-router-dom';

function TeamManagement({ 
  organization, 
  teams, 
  defaultTeamId, 
  user, 
  onBack, 
  onViewTeamLeads,
  isMobile,
  isTablet 
}) {
  const [allUsers, setAllUsers] = useState([]); // Ungefilterte Benutzer
  const [error, setError] = useState('');
  const [showCreateTeam, setShowCreateTeam] = useState(false);
  const [newTeamName, setNewTeamName] = useState('');
  const [showCreateUserDialog, setShowCreateUserDialog] = useState(false);
  const [showEditUserDialog, setShowEditUserDialog] = useState(false);
  const [selectedUserForEdit, setSelectedUserForEdit] = useState(null);

  // Filter State
  const [filters, setFilters] = useState({
    sortBy: 'name', // name, role, team
    sortOrder: 'asc', // asc, desc
    searchName: '',
    roleFilter: '',
    teamFilter: ''
  });

  const isAdmin = user?.isAdmin || false;
  const isOrgLeader = user?.isOrgLeader || false;
  const isTeamLeader = user?.isTeamlead || false;

  // Responsive Styles - gleich wie in Leads.js
  const styles = {
    container: {
      margin: '0 auto',
      maxWidth: '1400px',
      padding: isMobile ? '5px' : '15px',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: isMobile ? 'flex-start' : 'center',
      marginBottom: '15px',
      flexDirection: isMobile ? 'column' : 'row',
      gap: isMobile ? '10px' : '0',
    },
    title: {
      color: '#2d3748',
      fontSize: isMobile ? '1.2rem' : '1.6rem',
      margin: 0,
    },
    backButton: {
      padding: '8px 16px',
      background: '#4a6de5',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontWeight: '500',
      fontSize: '14px',
      marginBottom: isMobile ? '10px' : '0',
      transition: 'background-color 0.2s',
      width: 'auto',
      minWidth: 'fit-content',
    },
    sectionHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '15px',
    },
    sectionTitle: {
      fontSize: isMobile ? '1.1rem' : '1.3rem',
      color: '#2d3748',
      margin: 0,
    },
    buttonGroup: {
      display: 'flex',
      gap: '10px',
      flexDirection: isMobile ? 'column' : 'row',
    },
    createButton: {
      padding: '8px 16px',
      background: '#0a9a22',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontWeight: '500',
      fontSize: '14px',
      transition: 'background-color 0.2s',
      width: 'auto',
      minWidth: 'fit-content',
    },
    addUserButton: {
      padding: '8px 16px',
      background: '#38a169',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontWeight: '500',
      fontSize: '14px',
      transition: 'background-color 0.2s',
      width: 'auto',
      minWidth: 'fit-content',
    },
    // Filter Styles
    filters: {
      background: 'white',
      borderRadius: '6px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      padding: isMobile ? '10px' : '15px',
      marginBottom: '15px',
    },
    filterRow: {
      display: 'flex',
      gap: isMobile ? '8px' : '15px',
      marginBottom: '12px',
      flexWrap: 'wrap',
      flexDirection: isMobile ? 'column' : 'row',
    },
    filterGroup: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: isMobile ? 'auto' : '120px',
      flex: isMobile ? '1' : 'none',
    },
    filterLabel: {
      fontSize: '0.8rem',
      fontWeight: '500',
      color: '#4a5568',
      marginBottom: '4px',
    },
    filterInput: {
      padding: '6px 8px',
      border: '1px solid #e2e8f0',
      borderRadius: '4px',
      fontSize: '0.8rem',
    },
    resetButton: {
      padding: '6px 12px',
      backgroundColor: '#f3f4f6',
      color: '#4b5563',
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      fontSize: '0.8rem',
      cursor: 'pointer',
      marginTop: isMobile ? '8px' : '15px',
      width: isMobile ? '100%' : 'auto',
    },
    createForm: {
      background: 'white',
      borderRadius: '6px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      padding: isMobile ? '10px' : '15px',
      marginBottom: '15px',
      display: 'flex',
      gap: '8px',
      flexDirection: isMobile ? 'column' : 'row',
    },
    formInput: {
      padding: '6px 8px',
      border: '1px solid #e2e8f0',
      borderRadius: '4px',
      fontSize: '0.8rem',
      flex: isMobile ? '1' : 'auto',
      minWidth: isMobile ? 'auto' : '200px',
    },
    formButton: {
      padding: '6px 12px',
      border: 'none',
      borderRadius: '4px',
      fontSize: '0.8rem',
      cursor: 'pointer',
      fontWeight: '500',
    },
    submitButton: {
      background: '#0a9a22',
      color: 'white',
    },
    cancelButton: {
      background: '#f3f4f6',
      color: '#4b5563',
      border: '1px solid #d1d5db',
    },
    tableContainer: {
      background: 'white',
      borderRadius: '6px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      overflow: 'auto',
      WebkitOverflowScrolling: 'touch',
      maxHeight: '70vh',
      marginBottom: '20px',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      minWidth: isMobile ? '700px' : isTablet ? '800px' : 'auto',
      fontSize: isMobile ? '0.7rem' : isTablet ? '0.75rem' : '0.85rem',
    },
    th: {
      background: '#f7fafc',
      padding: isMobile ? '6px 4px' : isTablet ? '8px 6px' : '10px 8px',
      textAlign: 'left',
      fontWeight: '600',
      color: '#4a5568',
      borderBottom: '1px solid #e2e8f0',
      fontSize: isMobile ? '0.65rem' : isTablet ? '0.7rem' : '0.75rem',
      whiteSpace: 'nowrap',
      position: 'sticky',
      top: 0,
      zIndex: 10,
    },
    td: {
      padding: isMobile ? '6px 4px' : isTablet ? '8px 6px' : '10px 8px',
      borderBottom: '1px solid #e2e8f0',
      fontSize: isMobile ? '0.65rem' : isTablet ? '0.7rem' : '0.75rem',
      maxWidth: isMobile ? '80px' : isTablet ? '100px' : '150px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    roleBadge: {
      display: 'inline-block',
      padding: isMobile ? '0.15rem 0.3rem' : '0.2rem 0.5rem',
      borderRadius: '0.25rem',
      fontSize: isMobile ? '0.55rem' : '0.65rem',
      fontWeight: '500',
      textAlign: 'center',
      whiteSpace: 'nowrap',
      minWidth: isMobile ? '35px' : '50px',
      maxWidth: isMobile ? '70px' : '90px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      backgroundColor: '#e2e8f0',
      color: '#4a5568',
    },
    actionButton: {
      padding: isMobile ? '3px 6px' : '4px 8px',
      fontSize: isMobile ? '0.6rem' : '0.7rem',
      margin: '1px',
      border: 'none',
      borderRadius: '3px',
      cursor: 'pointer',
      fontWeight: '500',
      transition: 'background-color 0.2s',
    },
    actionButtons: {
      display: 'flex',
      gap: '4px',
      flexWrap: 'wrap',
    },
    editButton: {
      background: '#3182ce',
      color: 'white',
    },
    activateButton: {
      background: '#38a169',
      color: 'white',
    },
    deactivateButton: {
      background: '#d69e2e',
      color: 'white',
    },
    removeButton: {
      background: '#e53e3e',
      color: 'white',
    },
    statusBadge: {
      display: 'inline-block',
      padding: isMobile ? '0.15rem 0.3rem' : '0.2rem 0.5rem',
      borderRadius: '0.25rem',
      fontSize: isMobile ? '0.55rem' : '0.65rem',
      fontWeight: '500',
      textAlign: 'center',
      whiteSpace: 'nowrap',
      minWidth: isMobile ? '35px' : '50px',
      maxWidth: isMobile ? '70px' : '90px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    activeStatus: {
      backgroundColor: '#c6f6d5',
      color: '#2f855a',
    },
    inactiveStatus: {
      backgroundColor: '#fed7d7',
      color: '#c53030',
    },
    section: {
      marginBottom: '30px',
    },
    loading: {
      textAlign: 'center',
      padding: '20px',
      color: '#4a5568',
      fontSize: '0.9rem',
    },
    emptyTeams: {
      textAlign: 'center',
      padding: '20px',
      color: '#718096',
      fontSize: '0.9rem',
      background: 'white',
      borderRadius: '12px',
      border: '2px dashed #e2e8f0',
    },
    mobileScrollHint: {
      textAlign: 'center',
      padding: '8px',
      fontSize: '0.7rem',
      color: '#718096',
      background: '#f7fafc',
      borderTop: '1px solid #e2e8f0',
    },
    // Neue Styles für Team-Karten
    teamsGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : isTablet ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
      gap: isMobile ? '12px' : '16px',
      marginBottom: '20px',
    },
    teamCard: {
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      padding: isMobile ? '16px' : '20px',
      border: '1px solid #e2e8f0',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      position: 'relative',
      overflow: 'hidden',
    },
    teamCardHover: {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
    },
    teamCardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '12px',
    },
    teamName: {
      fontSize: isMobile ? '1rem' : '1.1rem',
      fontWeight: '600',
      color: '#2d3748',
      margin: 0,
      lineHeight: '1.3',
      flex: 1,
    },
    defaultBadgeCard: {
      backgroundColor: '#c6f6d5',
      color: '#2f855a',
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: isMobile ? '0.6rem' : '0.7rem',
      fontWeight: '500',
      whiteSpace: 'nowrap',
      marginLeft: '8px',
    },
    teamStats: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '16px',
    },
    memberCount: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      color: '#4a5568',
      fontSize: isMobile ? '0.8rem' : '0.9rem',
    },
    memberIcon: {
      width: '16px',
      height: '16px',
      fill: '#4a5568',
    },
    teamActions: {
      display: 'flex',
      gap: '8px',
      flexWrap: 'wrap',
    },
    cardButton: {
      padding: isMobile ? '6px 10px' : '8px 12px',
      fontSize: isMobile ? '0.7rem' : '0.8rem',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontWeight: '500',
      transition: 'all 0.2s ease',
      flex: 1,
      minWidth: 'fit-content',
    },
    viewCardButton: {
      backgroundColor: '#4a6de5',
      color: 'white',
    },
    deleteCardButton: {
      backgroundColor: '#fee2e2',
      color: '#dc2626',
    },
  };

  // Filter anwenden
  useEffect(() => {
    if (!allUsers.length) return;
    
    let filteredUsers = [...allUsers];
    
    // Name-Filter
    if (filters.searchName) {
      filteredUsers = filteredUsers.filter(userData => 
        (userData.full_name && userData.full_name.toLowerCase().includes(filters.searchName.toLowerCase())) ||
        (userData.email && userData.email.toLowerCase().includes(filters.searchName.toLowerCase()))
      );
    }
    
    // Rolle-Filter
    if (filters.roleFilter) {
      filteredUsers = filteredUsers.filter(userData => 
        getUserRole(userData.role_type) === filters.roleFilter
      );
    }
    
    // Team-Filter
    if (filters.teamFilter) {
      filteredUsers = filteredUsers.filter(userData => 
        getUserTeam(userData.team_id) === filters.teamFilter
      );
    }
    
    // Sortierung
    filteredUsers.sort((a, b) => {
      let aValue, bValue;
      
      if (filters.sortBy === 'name') {
        aValue = (a.full_name || a.email || '').toLowerCase();
        bValue = (b.full_name || b.email || '').toLowerCase();
      } else if (filters.sortBy === 'role') {
        aValue = getUserRole(a.role_type).toLowerCase();
        bValue = getUserRole(b.role_type).toLowerCase();
      } else if (filters.sortBy === 'team') {
        aValue = getUserTeam(a.team_id).toLowerCase();
        bValue = getUserTeam(b.team_id).toLowerCase();
      } else {
        aValue = (a.full_name || a.email || '').toLowerCase();
        bValue = (b.full_name || b.email || '').toLowerCase();
      }
      
      if (filters.sortOrder === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });

  }, [allUsers, filters]);

  const handleFilterChange = (filterName, value) => {
    setFilters(prev => ({
      ...prev,
      [filterName]: value
    }));
  };

  const resetFilters = () => {
    setFilters({
      sortBy: 'name',
      sortOrder: 'asc',
      searchName: '',
      roleFilter: '',
      teamFilter: ''
    });
  };

  // Benutzer aus Team entfernen (nur für Teamleiter)
  const handleRemoveFromTeam = async (userId, userName) => {
    if (!window.confirm(`Sind Sie sicher, dass Sie ${userName} aus dem Team entfernen möchten?`)) {
      return;
    }

    setError('');

    try {
      const response = await removeUserFromTeam(user.id, userId, user.team.id);
      
      if (response.success) {
      } else {
        setError(response.error || 'Fehler beim Entfernen des Benutzers');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
    }
  };

  // Neues Team erstellen
  const handleCreateTeam = async (e) => {
    e.preventDefault();
    
    if (!newTeamName.trim()) {
      setError('Bitte geben Sie einen Team-Namen ein.');
      return;
    }
    setError('');

    try {
      const response = await createTeam(user.id, organization.id, newTeamName);
      
      if (response.success) {
        setNewTeamName('');
        setShowCreateTeam(false);
        // Seite neu laden um neue Teams zu sehen
        window.location.reload();
      } else {
        setError(response.error || 'Fehler beim Erstellen des Teams');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
    }
  };

  // Team löschen
  const handleDeleteTeam = async (teamId, teamName) => {
    if (!window.confirm(`Sind Sie sicher, dass Sie das Team "${teamName}" löschen möchten? Alle Benutzerzuordnungen werden entfernt.`)) {
      return;
    }

    setError('');

    try {
      const response = await deleteTeam(user.id, teamId);
      
      if (response.success) {
        // Seite neu laden um aktualisierte Teams zu sehen
        window.location.reload();
      } else {
        setError(response.error || 'Fehler beim Löschen des Teams');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
    }
  };

  // Benutzerrolle als Text zurückgeben
  const getUserRole = (roleType) => {
    switch (roleType) {
      case 2: return 'Teamleiter';
      case 3: return 'Org-Leiter';
      case 6: return 'Fachberater';
      default: return 'Benutzer';
    }
  };

  // Team-Name für Benutzer zurückgeben
  const getUserTeam = (teamId) => {
    if (!teamId) return '-';
    const team = teams.find(t => t.id === teamId);
    return team ? team.name : 'Unbekanntes Team';
  };

  // Text kürzen für mobile Anzeige
  const truncateText = (text, maxLength) => {
    if (!text) return '-';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  // Benutzer erstellen Dialog öffnen
  const handleCreateUser = () => {
    setShowCreateUserDialog(true);
  };

  // Benutzer erstellen Dialog schließen
  const handleCloseCreateUserDialog = () => {
    setShowCreateUserDialog(false);
  };

  // Edit-Dialog schließen
  const handleCloseEditUserDialog = () => {
    setShowEditUserDialog(false);
    setSelectedUserForEdit(null);
  };

  // Edit-Dialog speichern
  const handleSaveEditUser = () => {
    setShowEditUserDialog(false);
    setSelectedUserForEdit(null);
  };

  // Aktuelles Team des Benutzers finden
  const userTeam = teams.find(team => team.id === user.team?.id);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button 
          style={styles.backButton}
          onClick={onBack}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#3c5ce0';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#4a6de5';
          }}
        >
          ← Zurück
        </button>
        <h2 style={styles.title}>
          {isTeamLeader ? 
            `Mein Team: ${userTeam?.name || 'Kein Team'}` : 
            `${organization.name} - Team Verwaltung`
          }
        </h2>
      </div>

      {error && <div style={styles.error}>{error}</div>}

      {/* Teams Sektion - nur für Admin/OrgLeiter anzeigen */}
      {(isAdmin || isOrgLeader) && (
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <h3 style={styles.sectionTitle}>Teams</h3>
            <div style={styles.buttonGroup}>
              <button
                style={styles.createButton}
                onClick={handleCreateUser}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#078a1a';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#0a9a22';
                }}
              >
                Benutzer Hinzufügen
              </button>
              <button
                style={styles.createButton}
                onClick={() => setShowCreateTeam(!showCreateTeam)}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#078a1a';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#0a9a22';
                }}
              >
                {showCreateTeam ? 'Abbrechen' : '+ Neues Team'}
              </button>
              {/* Sub-Teams functionality removed */}
            </div>
          </div>

          {showCreateTeam && (
            <form onSubmit={handleCreateTeam} style={styles.createForm}>
              <input
                type="text"
                placeholder="Team-Name eingeben"
                value={newTeamName}
                onChange={(e) => setNewTeamName(e.target.value)}
                style={styles.formInput}
                required
              />
              <button type="submit" style={{...styles.formButton, ...styles.submitButton}}>
                Erstellen
              </button>
              <button 
                type="button" 
                onClick={() => {
                  setShowCreateTeam(false);
                  setNewTeamName('');
                }}
                style={{...styles.formButton, ...styles.cancelButton}}
              >
                Abbrechen
              </button>
            </form>
          )}

          {/* Teams-Tabelle */}
                     <div style={styles.teamsGrid}>
             {teams.length === 0 ? (
               <div style={styles.emptyTeams}>
                 Keine Teams gefunden
               </div>
             ) : (
               teams.map((team) => (
                 <div 
                   key={team.id} 
                   style={styles.teamCard}
                   onMouseEnter={(e) => {
                     e.target.style.transform = 'translateY(-2px)';
                     e.target.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.15)';
                   }}
                   onMouseLeave={(e) => {
                     e.target.style.transform = 'translateY(0)';
                     e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                   }}
                 >
                   <div style={styles.teamCardHeader}>
                     <h4 style={styles.teamName} title={team.name}>
                       {truncateText(team.name, isMobile ? 12 : isTablet ? 15 : 25)}
                     </h4>
                     {team.is_default && (
                       <span style={styles.defaultBadgeCard}>
                         Standard
                       </span>
                     )}
                   </div>
                   <div style={styles.teamStats}>
                     <span style={styles.memberCount}>
                       <svg style={styles.memberIcon} viewBox="0 0 24 24">
                         <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H17c-.8 0-1.54.37-2.01 1l-1.7 2.26A6.003 6.003 0 0 0 10 16v6h10zm-8-2v-4c0-1.1.9-2 2-2s2 .9 2 2v4h-4z"/>
                       </svg>
                       {team.memberCount || 0} Mitglieder
                     </span>
                   </div>
                   <div style={styles.teamActions}>
                     <button
                       style={{...styles.cardButton, ...styles.viewCardButton}}
                       onClick={() => onViewTeamLeads && onViewTeamLeads(team.id, team.name)}
                       title="Team-Leads anzeigen"
                       onMouseEnter={(e) => {
                         e.target.style.backgroundColor = '#3c5ce0';
                       }}
                       onMouseLeave={(e) => {
                         e.target.style.backgroundColor = '#4a6de5';
                       }}
                     >
                       {isMobile ? 'Leads' : 'Anzeigen'}
                     </button>
                     {!team.is_default && (
                       <button
                         style={{...styles.cardButton, ...styles.deleteCardButton}}
                         onClick={() => handleDeleteTeam(team.id, team.name)}
                         title="Team löschen"
                         onMouseEnter={(e) => {
                           e.target.style.backgroundColor = '#fecaca';
                         }}
                         onMouseLeave={(e) => {
                           e.target.style.backgroundColor = '#fee2e2';
                         }}
                       >
                         {isMobile ? '✕' : 'Löschen'}
                       </button>
                     )}
                   </div>
                 </div>
               ))
             )}
           </div>
        </div>
      )}

      {/* CreateUser Dialog */}
      {showCreateUserDialog && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div className="modal-dialog" style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
            width: '90%',
            maxWidth: '800px',
            maxHeight: '90vh',
            overflow: 'auto',
            position: 'relative'
          }}>
            <div className="modal-header" style={{
              display: 'flex',
              alignItems: 'center',
              padding: '20px',
              borderBottom: '1px solid #e2e8f0',
              marginBottom: '20px',
              position: 'relative'
            }}>
              <h3 style={{ 
                margin: 0, 
                fontSize: isMobile ? '1.2rem' : '1.5rem', 
                fontWeight: '600',
                width: '80%',
                textAlign: 'left'
              }}>
                Neuen Benutzer erstellen
              </h3>
              <button 
                className="close-button" 
                onClick={handleCloseCreateUserDialog}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  width: '40px',
                  height: '40px',
                  borderRadius: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'background-color 0.2s',
                  marginLeft: 'auto',
                  flexShrink: 0
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f1f5f9'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            <div className="modal-content" style={{ padding: '0 20px 20px 20px' }}>
              <CreateUser 
                user={user} 
                onClose={handleCloseCreateUserDialog}
                preselectedTeamId={null} // Kein spezifisches Team vorauswählen
                showAgenturSelection={true} // Agenturen anzeigen
              />
            </div>
          </div>
        </div>
      )}

      {/* EditUser Dialog */}
      {showEditUserDialog && selectedUserForEdit && (
        <EditUserDialog
          user={user}
          targetUser={selectedUserForEdit}
          onSave={handleSaveEditUser}
          onCancel={handleCloseEditUserDialog}
          isMobile={isMobile}
          isTablet={isTablet}
        />
      )}
    </div>
  );
}

export default TeamManagement;